import { HttpErrorResponse } from '@angular/common/http';
import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { ProductPriceListResponse } from 'src/app/models/price-list.model';
import { ResponseObject } from 'src/app/models/response-object.model';
import { InventoryService } from 'src/app/services/inventory.service';

@Component({
  selector: 'app-price-list-group',
  templateUrl: './price-list-group.component.html',
  styleUrls: ['./price-list-group.component.scss']
})
export class PriceListGroupComponent implements OnInit, OnChanges {
  @Output() priceListEvent = new EventEmitter<ProductPriceListResponse>();
  @Input() saving!: number;
  priceListLists: ProductPriceListResponse [] = [];
  priceListSelected: ProductPriceListResponse = null;
  priceListSelectedId: number = null;
  pagination = {
    total: [],
    filter: [],
    pageSize: 5,
    startElement: 0,
    lastElement: 0,
    pageIndex: 0
  }
  filterWord: string = null;
  editList: { [key: number]: boolean } = {};

  constructor(private inventoryService: InventoryService, 
    private toastService: ToastrService){}

  ngOnInit(): void {
      this.getPriceList();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['saving']) {
      this.getPriceList();
    }
  }

  getPriceList(){
    this.inventoryService.getProductPricesList().subscribe({
      next: (response: ResponseObject) => {
        this.priceListLists = response.data;
        this.pagination.filter = this.priceListLists;
        this.pagination.total = this.priceListLists;
        this.resetPagination();
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error("No se pueden obtener las listas de precios.", "Error")
      }
    });
  }

  resetPagination() {
    this.pagination.filter = this.pagination.total.slice(0, this.pagination.pageSize);
    this.pagination.pageIndex = 0;
    this.pagination.lastElement = this.pagination.filter.length;
    this.pagination.startElement = 0;
  }

  setPriceListSelected(priceList: ProductPriceListResponse){
    this.priceListSelected = priceList;
    this.priceListSelectedId = this.priceListSelected.id;
    this.priceListEvent.emit(this.priceListSelected);
  }

  onInputChange(event: Event) {
    const value = (event.target as HTMLInputElement).value;
    this.filterWord = value;
    this.searching();
  }

  searching() {
    this.pagination.total = this.priceListLists.filter((list) => {
      const filter = this.filterWord.toLowerCase();

      return (
        list.id + '' === this.filterWord || // sigue permitiendo búsqueda exacta por id
        list.name.toLowerCase().includes(filter) // búsqueda parcial por nombre
      );
    });

    this.pagination.pageIndex = 0;
    this.pagination.startElement = 0;
    this.pagination.filter = this.pagination.total.slice(0, this.pagination.pageSize);
    this.pagination.lastElement = this.pagination.filter.length;
  }

  updateList(list: ProductPriceListResponse){
    this.inventoryService.putProductPricesList(list.id, {name: list.name}).subscribe({
      next: (response: ResponseObject) => {
        this.toastService.success("Lista actualizada correctamente.", "Exito");
        this.editList[list.id] = false;
        this.getPriceList();
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error("No se actualizo el nombre de la lista", "Error");
      }
    });
  }

  deleteList(list: ProductPriceListResponse){
    this.inventoryService.deleteProductPricesList(list.id).subscribe({
      next: (response: ResponseObject) => {
        this.toastService.success("Lista eliminada correctamente.", "Exito");
        this.getPriceList();
        this.priceListSelected = null;
        this.priceListSelectedId = null;
        this.priceListEvent.emit(null);
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error("No se pudo elimino la lista", "Error");
      }
    });
  }

  editingName(priceList: ProductPriceListResponse) {
      if(this.editList[priceList.id]) {
        this.editList[priceList.id] = false;
        return;
      }
      this.editList[priceList.id] = true;
    }
  
}
